import React, { useContext } from "react";
import style from "./index.module.scss";
import { useNavigate } from "react-router-dom";

import defaultHead from "@/assets/images/user_default.png";

import PubSub from "pubsub-js";
import { rootContext } from "@/context/rootContext";
import filterGameData from "@/assets/data/gameData";

function HeadUser(props) {

  const navigate = useNavigate();

  const { creatorData, langState } = useContext(rootContext);

  const logout = () => {
    window.gtag("event", "pc_logout");
    PubSub.publish("logout", null);
  };

  const joinDiscord = () => {
    if (creatorData) {
      window.gtag("event", "pc_contact_us");
      const link = filterGameData("discordLink");
      window.open(link);
    }
  };

  return (
    <div className={style.head_content}>
      <div className={style.head_icon}>
        <img src={defaultHead}></img>
        { creatorData && creatorData.games.filter(item => item.tag === "farlight84" && !item.inEffect).length && <i className={style.tip}></i> }
      </div>
      <div className={`head_nav ${style.head_nav}`}>
        <ul>
          {
            !props.onlogup && creatorData && creatorData.isCreator && creatorData.realInfo.length && (
              <li onClick={() => { window.gtag("event", "pc_profile"); navigate("/information"); }}>
                <i className={style.icon1}></i>
                { creatorData && creatorData.games.filter(item => item.tag === "farlight84" && !item.inEffect).length > 0 && <i className={style.tip}></i> }
                <p>{ langState.topNavData.profile }</p>
              </li>
            )
          }
          {
            !props.onlogup && creatorData && creatorData.isCreator && creatorData.realInfo.length && (
              <li onClick={joinDiscord}>
                <i className={style.icon2}>?</i>
                <p>{langState.topNavData.contact}</p>
              </li>
            )
          }
          <li onClick={logout}>
            <i className={style.icon3}></i>
            <p>{langState.topNavData.logOut}</p>
          </li>
        </ul>
      </div>
    </div>
  );

}

export default HeadUser;
